<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-brand">
        <img
          class="footer-logo"
          src="@/assets/logoGex1.2.png"
          alt="GEX - Gestão de Extensão"
        />
        <p class="footer-description">
          Sistema de Gestão de Extensão da Universidade Federal do Ceará.
        </p>
        <div class="social">
          <a
            href="https://prex.ufc.br/pt/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Site da PRÓ-REITORIA DE EXTENSÃO"
            title="Site da PRÓ-REITORIA DE EXTENSÃO"
          >
            <i class="fa-solid fa-globe"></i>
          </a>

          <a
            href="https://www.instagram.com/prexufc/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            title="Instagram"
          >
            <i class="fab fa-instagram"></i>
          </a>

          <a
            href="https://www.facebook.com/prexufc"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            title="Facebook"
          >
            <i class="fab fa-facebook-f"></i>
          </a>

          <a
            href="https://www.flickr.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Flickr"
            title="Flickr"
          >
            <i class="fab fa-flickr"></i>
          </a>
        </div>
      </div>
      <div class="footer-col">
        <h3>Páginas</h3>

        <ul class="paginas-lista">
          <li>
            <router-link to="/">
              <span>Início</span>
            </router-link>
          </li>

          <li v-if="isLogado">
            <router-link to="/suas-acoes">
              <span>Minhas ações</span>
            </router-link>
          </li>

          <li>
            <router-link to="/Atividades">
              <span>Atividades</span>
            </router-link>
          </li>

          <li>
            <router-link to="/Noticias">
              <span>Notícias</span>
            </router-link>
          </li>
          <li>
            <router-link to="/Vagas">
              <span>Vagas</span>
            </router-link>
          </li>
          <li>
            <router-link to="/Parcerias">
              <span>Parcerias</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="footer-col footer-contact">
        <h3>Entre em contato</h3>

        <div class="contact-item">
          <div class="contact-icon">
            <i class="fas fa-map-marker-alt"></i>
          </div>

          <p>
            Campus do Pici – Antigo prédio da CCV, ao lado da PROGRAD e
            Biblioteca Central – CEP 60440-554 – Fortaleza – CE
          </p>
        </div>

        <div class="contact-item">
          <div class="contact-icon">
            <i class="fas fa-envelope"></i>
          </div>

          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=prex.gabinete@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            prex.gabinete@gmail.com
          </a>
        </div>

        <div class="contact-item">
          <div class="contact-icon">
            <i class="fas fa-phone"></i>
          </div>

          <div class="phone-list">
            <span>3366-9426 <small>Secretaria</small></span>
            <span>3366-9478 <small>Recepção</small></span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <span>
          © {{ anoAtual }} NERDS – Núcleo Especializado em Reengenharia e
          Desenvolvimento de Software. Todos os direitos reservados.</span
        >
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";

const auth = useAuthStore();

const { isAutenticado, estaRenovando } = storeToRefs(auth);

const isLogado = computed(() => isAutenticado.value || estaRenovando.value);

const anoAtual = new Date().getFullYear();
</script>

<style scoped>
.footer {
  width: 100%;
  background: linear-gradient(135deg, #32186f 0%, #3b2078 45%, #4a2990 100%);

  color: #ffffff;
  padding: 48px 40px 0;
  font-size: 14px;
}

.footer-container {
  width: 100%;
  max-width: 1250px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 1.2fr 0.8fr 1.8fr;
  gap: 70px;

  padding-bottom: 40px;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-logo {
  width: 165px;
  height: auto;
  object-fit: contain;
  margin-bottom: 16px;
}

.footer-description {
  max-width: 300px;
  margin: 0 0 22px;

  color: rgba(255, 255, 255, 0.78);
  line-height: 1.6;
  font-size: 13px;
}

.social {
  display: flex;
  align-items: center;
  gap: 10px;
}

.social a {
  width: 38px;
  height: 38px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;

  color: #ffffff;
  text-decoration: none;

  background: rgba(255, 255, 255, 0.08);

  transition:
    transform 0.2s ease,
    background 0.2s ease,
    border-color 0.2s ease;
}

.social a:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.4);
}

.footer-col h3 {
  position: relative;

  margin: 0 0 20px;

  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.paginas-lista {
  display: flex;
  flex-direction: column;

  gap: 11px;

  list-style: none;
  margin: 0;
  padding: 0;
}

.paginas-lista li {
  margin: 0;
}

.paginas-lista a {
  display: inline-flex;
  align-items: center;

  gap: 10px;

  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;

  transition:
    color 0.2s ease,
    transform 0.2s ease;
}

.paginas-lista a i {
  width: 16px;
  text-align: center;

  font-size: 13px;
}

.paginas-lista a:hover {
  color: #ffffff;
  transform: translateX(4px);
}

.footer-contact {
  min-width: 0;
}

.contact-item {
  display: flex;
  align-items: flex-start;

  gap: 13px;

  margin-bottom: 16px;

  color: rgba(255, 255, 255, 0.78);
  line-height: 1.55;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-icon {
  flex: 0 0 24px;

  display: flex;
  justify-content: center;

  padding-top: 2px;

  color: rgba(255, 255, 255, 0.95);
}

.contact-item p {
  margin: 0;
}

.contact-item a {
  color: rgba(255, 255, 255, 0.82);
  text-decoration: none;

  transition: color 0.2s ease;
}

.contact-item a:hover {
  color: #ffffff;
  text-decoration: underline;
}

.phone-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.phone-list span {
  display: flex;
  align-items: center;
  gap: 7px;
}

.phone-list small {
  color: rgba(255, 255, 255, 0.55);
  font-size: 11px;
}

.footer-bottom {
  width: 100%;
  max-width: 1250px;

  margin: 0 auto;
}

.footer-bottom-content {
  min-height: 58px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: rgba(255, 255, 255, 0.55);

  font-size: 11px;
  line-height: 1.5;
}

@media (max-width: 1000px) {
  .footer {
    padding: 40px 30px 0;
  }

  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-description {
    max-width: 500px;
  }
}

@media (max-width: 650px) {
  .footer {
    padding: 35px 22px 0;
  }

  .footer-container {
    display: flex;
    flex-direction: column;

    gap: 32px;

    padding-bottom: 30px;
  }

  .footer-brand,
  .footer-col {
    width: 100%;
  }

  .footer-brand {
    align-items: center;
    text-align: center;
  }

  .footer-description {
    max-width: 350px;
  }

  .social {
    justify-content: center;
  }

  .footer-col h3 {
    margin-bottom: 16px;
  }

  .paginas-lista {
    gap: 10px;
  }

  .footer-contact {
    width: 100%;
  }

  .contact-item {
    max-width: 100%;
  }

  .footer-bottom-content {
    flex-direction: column;

    justify-content: center;
    text-align: center;

    padding: 16px 0 20px;
    gap: 5px;
  }

  .footer-rights {
    white-space: normal;
  }
}

@media (max-width: 400px) {
  .footer {
    padding-left: 16px;
    padding-right: 16px;
  }
  .footer-col h3 {
    text-align: center;
  }
  .paginas-lista {
    text-align: center;
  }

  .footer-logo {
    width: 145px;
  }

  .footer {
    font-size: 13px;
  }

  .social a {
    width: 35px;
    height: 35px;
  }
}
</style>
